import type { MobilePreset } from '@/lib/api/controlPlaneClient'
import { OverrideSelect } from './OverrideSelect'
import {
  PRESET_DEFAULTS,
  OVERRIDE_FIELDS,
  OVERRIDE_OPTIONS,
  OVERRIDE_LABELS,
  type PresetDefaults,
  type OverrideField,
} from './preset-defaults'

interface OverrideControlsProps {
  preset: MobilePreset
  overrides: PresetDefaults
  onOverrideChange: (field: OverrideField, value: string) => void
  onResetField: (field: OverrideField) => void
  isLoading?: boolean
  /** Optional title — defaults to "ปรับแต่ง" */
  title?: string
  /** Show only these fields. If omitted, shows all. */
  fields?: readonly OverrideField[]
}

export function OverrideControls({
  preset,
  overrides,
  onOverrideChange,
  onResetField,
  isLoading,
  title = 'ปรับแต่ง',
  fields,
}: OverrideControlsProps) {
  const defaults = PRESET_DEFAULTS[preset]
  const displayFields = fields ?? OVERRIDE_FIELDS

  if (isLoading) {
    return (
      <div>
        <div className="mb-4 text-[13px] font-semibold text-gray-500">{title}</div>
        <div className="flex flex-col gap-4">
          {displayFields.map((f) => (
            <div key={f}>
              <div className="mb-1 h-4 w-20 animate-pulse rounded-md bg-gray-100 motion-reduce:animate-none" />
              <div className="h-[42px] w-full animate-pulse rounded-sm bg-gray-100 motion-reduce:animate-none" />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="mb-4 text-[13px] font-semibold text-gray-500">{title}</div>
      <div className="flex flex-col gap-4">
        {displayFields.map((field) => (
          <OverrideSelect
            key={field}
            id={`override-${field}`}
            label={OVERRIDE_LABELS[field]}
            value={overrides[field]}
            defaultValue={defaults[field]}
            options={OVERRIDE_OPTIONS[field]}
            onChange={(value) => onOverrideChange(field, value)}
            onReset={() => onResetField(field)}
          />
        ))}
      </div>
    </div>
  )
}

